// Swaps the main product image when a thumbnail is chosen; slides stay in the DOM for zoom buttons.
class SProductGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      const thumb = event.target instanceof Element ? event.target.closest('[data-gallery-thumb]') : null;
      if (!thumb || !this.contains(thumb)) return;
      this.#show(Number(thumb.getAttribute('data-gallery-thumb')));
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #show(index) {
    const slides = this.querySelectorAll('[data-gallery-slide]');
    const thumbs = this.querySelectorAll('[data-gallery-thumb]');
    if (!slides[index]) return;

    const swap = () => {
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const img = slides[index].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    };

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && document.startViewTransition) {
      document.startViewTransition(swap);
    } else {
      swap();
    }
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
